module.exports = __webpack_public_path__ + "static/media/footerImage.09c6be0f.png";